import type { EventName } from "@lit/react";
import { DateTimePicker as DateTimePickerElement, type DateTimePickerEventMap as _DateTimePickerEventMap, } from "@vaadin/date-time-picker/vaadin-date-time-picker.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DateTimePickerElement, };
export type DateTimePickerEventMap = Readonly<{
    onValidated: EventName<_DateTimePickerEventMap["validated"]>;
    onChange: EventName<_DateTimePickerEventMap["change"]>;
    onInvalidChanged: EventName<_DateTimePickerEventMap["invalid-changed"]>;
    onValueChanged: EventName<_DateTimePickerEventMap["value-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onInvalidChanged: "invalid-changed", onValueChanged: "value-changed" } as DateTimePickerEventMap;
export type DateTimePickerProps = WebComponentProps<DateTimePickerElement, DateTimePickerEventMap>;
export const DateTimePicker = createComponent({
    elementClass: DateTimePickerElement, events, react: React, tagName: "vaadin-date-time-picker"
});
